import React, { Fragment } from "react"
import sanity from "../config/sanity"
import Meta from "../src/components/Meta"
import { CareerPage } from "../src/routes/CareerPage/CareerPage"

const Career = ({ sanityDoc }) => {
    return (
        <Fragment>
            {sanityDoc?.meta && (
                <Meta
                    title={sanityDoc?.meta.title ?? sanityDoc.title}
                    {...sanityDoc.meta}
                />
            )}

            <CareerPage content={sanityDoc} />
        </Fragment>
    )
}

export default Career

const careersQuery = `*[_type == "career"] {
    title,
    tagline,
    jobs, 
    image,
    jobsTitle,
    ...
  }[0]
  `

// This function gets called at build time on server-side.
export const getStaticProps = async () => {
    const sanityDoc = await sanity.fetch(careersQuery)
    return { props: { sanityDoc } }
}
